







































































import {Component, Mixins} from "vue-property-decorator";
import NumberGenerator from "@/common/mixins/numberGenerator";
import AllYouCanEatDrink from "@/common/mixins/allYouCanDrinkEat";
import OrderComponent from "@/components/order/orderComponent.vue";
import QDetailModal from "@/components/qDetailModal.vue";
import { ReloadManager } from "@/common/util/reloadManager";
import Table from "@/model/table";
import History from "@/model/history";
import moment from "moment/moment";
import Menu from "@/model/menu";
import Option from "@/model/option";
import {namespace} from "vuex-class";
import {NO_IMAGE_URL} from "@/common/constant";
import System from "@/model/system";
import historyApi from "@/api/historyApi";
import store from "@/store";

const menuStore = namespace("MenuStore");
const optionStore = namespace("OptionStore");
const systemStore = namespace("SystemStore");
const historyStore = namespace("HistoryStore");
const languageStore = namespace("LanguageStore");

@Component({
  name: "historyOrder",
  components: {OrderComponent, QDetailModal},
})

export default class HistoryOrder extends Mixins(NumberGenerator, AllYouCanEatDrink) {
  @menuStore.Getter
  getMenuList!: Menu[];
  @menuStore.Getter
  isShowNotAllYouCanEatMobile!: boolean;
  @menuStore.Action
  getMenuOnList;
  @optionStore.Getter
  getOptionList!: Option[];
  @systemStore.Getter
  getSystem!: System;
  @historyStore.Getter
  getHistories!: History[];
  @languageStore.Getter
  getMenuNameKey: string
  @languageStore.Getter
  getSubMenuNameKey: string

  public table = new Table();
  public noImageUrl = NO_IMAGE_URL;
  public menuTmp:Menu = null;
  public aycdFlag = false;

  async mounted() {
    ReloadManager.load(this.getSystem).connectSocket();
    await this.fetchOrderHistories();
  }

  private get namekey() {
    return this.getMenuNameKey;
  }

  get historyList(): History[] {
    return this.getHistories;
  }

  get totalQuantity () {
    // eslint-disable-next-line unicorn/no-array-reduce
    return this.getHistories.reduce((sum, value) => sum + value.quantity, 0)
  }

  get totalPrice () {
    // eslint-disable-next-line unicorn/no-array-reduce
    return this.getHistories.reduce((sum, value) => sum + value.quantity * value.price, 0)
  }

  public async openMenuDetail(menu) {
    let menuDetail: Menu = null;
    const historyList = [];
    this.getMenuList.map(item => {
      if (item.identifier === menu.identifier) {
        historyList.push(item);
      }

      if (historyList) {
        menuDetail = historyList[0];
      }
    })

    if (!menuDetail) {
      return;
    }
    if (this.getNameLabel(menuDetail) === "not-aycd") {
      this.aycdFlag = true;
      this.menuTmp = menuDetail;
      return;
    } else {
      this.detailModal(menuDetail, false);
    }
  }

  public getNameLabel(menu: Menu) {
    if (!menu.allYouCanEat) {
      return "not-aycd";
    } else {
      return "menu_detail"
    }
  }

  async fetchOrderHistories() {
    const histories = await historyApi.index()
    store.dispatch('HistoryStore/clear');
    histories.map(item => {
      store.dispatch('HistoryStore/addHistoryToList', item);
    })
  }

  public detailModal(menu, isEdit) {
    (this.$refs.qDetailModal as QDetailModal).show(menu, isEdit);
  }

  public timeFormat(time) {
    return moment(time).format('H:mm');
  }

  getImageFileName(identifyHistory) {
    let imageFileName = this.noImageUrl;
    this.getMenuList.filter(menu => {
      if (menu.identifier === identifyHistory && menu.imageFileName !== "") {
        imageFileName = menu.imageFileName
      }
    })

    return this.getSystem.image_endpoint + imageFileName;
  }

  canReorder(history: History) {
    return this.getMenuList.find(item => {
      let rtn = item.identifier === history.identifier;
      // @see https://qumitai.backlog.jp/view/HAYAWAZA-227
      if (this.isShowNotAllYouCanEatMobile) {
        rtn = rtn && item.allYouCanEat;
      }

      return rtn;
    });
  }

  private getName(history: History) {
    let response = "";

    const menu = this.getMenuList.find(value => {
      return value.identifier.toString() === history.identifier.toString();
    });
    if (!menu) {
      return history.name;
    }
    const namekey = this.getMenuNameKey;
    response = menu[namekey] || menu.name;
    const option = this.getOptionList.find((value) => {
      const isMatchId = value.identifier.toString() === history.identifier;
      const isMatchSubId = value.subIdentifier.toString() === history.subIdentifier.toString();
      return isMatchId && isMatchSubId;
    });
    const subNamekey = this.getSubMenuNameKey;
    if (!option) {
      return response;
    }
    const optionName = option[subNamekey] || option.subName;
    response += '(' + optionName + ')';

    return response;
  }
}
